import getAPIResponse from "./common/CommonPublic";

export async function resetPassword(email) {
    return await getAPIResponse("/api/v1/public/reset-password", {
        email: email
    }, "post");
}
